import Vue from 'vue';

export default {
  state: {
    directorsList: [
      { content: '', photo: { url: '' }, preview: { url: '' } },
    ],
  },
  mutations: {
    setDirectorsList(state, data) {
      state.directorsList = data;
    },
  },
  actions: {
    getDirectorsList(store) {
      const path = 'directors?_sort=sortNumber:asc';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setDirectorsList', resp.data);
        return resp.data;
      });
    },
  },
};
